import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseProductManagment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getProductStoreList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_ProductStoring?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateProductStore = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_ProductStoring`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getProductStoreList,
    updateProductStore,
  };
}
